import {AUDIO_EXTENSIONS, EML_EXTENSIONS, EXCEL_EXTENSIONS, IMAGE_EXTENSIONS, PDF_EXTENSIONS, POWERPOINT_EXTENSIONS, VIDEO_EXTENSIONS, WORD_EXTENSIONS} from 'constants/fileExtensions';
import {DocumentType} from 'types';

export const bufferToString = (buf: ArrayBuffer): string => {
  const arr = new Uint16Array(buf);
  return String.fromCharCode.apply(null, Array.from(arr));
};

export const getFileExtension = (fileName: string): string | undefined =>
  fileName.split('.')?.[1];

export const getFileTypeFromExtension = (
  fileName: string,
): DocumentType => {
  const ext = getFileExtension(fileName) || '';

  if (IMAGE_EXTENSIONS.includes(ext)) {
    return DocumentType.PICTURE;
  } else if (AUDIO_EXTENSIONS.includes(ext)) {
    return DocumentType.MUSIC;
  } else if (VIDEO_EXTENSIONS.includes(ext)) {
    return DocumentType.VIDEO;
  } else if (WORD_EXTENSIONS.includes(ext)) {
    return DocumentType.WORD;
  } else if (EML_EXTENSIONS.includes(ext)) {
    return DocumentType.EML;
  } else if (PDF_EXTENSIONS.includes(ext)) {
    return DocumentType.PDF;
  } else if (POWERPOINT_EXTENSIONS.includes(ext)) {
    return DocumentType.POWERPOINT;
  } else if (EXCEL_EXTENSIONS.includes(ext)) {
    return DocumentType.EXCEL;
  } else {
    return DocumentType.UNKNOWN;
  }
};

export const getDataURLFromFile = (file: File): Promise<string> =>
  new Promise<string>((resolve, reject) => {
    const reader = new FileReader();

    reader.addEventListener(
      'load',
      () => {
        if (!reader.result) {
          reject('File read result is empty');
        } else if (reader.result instanceof ArrayBuffer) {
          resolve(bufferToString(reader.result));
        } else {
          resolve(reader.result);
        }
      },
      false,
    );

    reader.readAsDataURL(file);
  });


  export const downloadFileFromURL = (url: string, fileName?: string) => {
    fetch(url)
      .then(async (response) => {
        if (response.ok) {
          const blob = await response.blob();
          if (!blob) {
            downloadFileFromURL(url, fileName);
            return;
          }
          const blobUrl = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
  
          a.href = blobUrl;
  
          if (fileName) {
            a.download = fileName;
          }
  
          document.body.appendChild(a);
          a.click();
          a.remove();
        }
      })
      .catch((error) => console.error(`Error getting blob ${url}`, error));
  };
  
  export const parseFileName = (filename: string) => {
    const filenameParts = filename.split('/');
    return filenameParts[filenameParts.length - 1];
  };